export * from './report.service';
import { ReportService } from './report.service';
export const APIS = [ReportService];
